<template>
  <div class="multipleLikeButton" @click="toggle">
    <i class="icon" :class="{ 'bookmark': checked, 'bookmark outline': !checked }"></i>
    <div class="text">保存</div>
    <div v-if="$root.selectedShopCount" class="ui floating circular label">{{ $root.selectedShopCount }}</div>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            checked: false
        };
    },
    props: {
        shopId: {
            require: true,
            type: Number
        }
    },
   created: function() {
        this.checked = _.includes(this.selectedShops(), this.shopId);
    },
    methods: {
        toggle: function() {
            const shops = this.selectedShops();
            if (!this.checked && shops.length >= 10) {
                alert('まとめて問い合わせリストに追加できるのは10件までです');
                return;
            }
            this.checked = !this.checked;
            _.remove(shops, function(shopId) {
                return this.shopId === shopId;
            }.bind(this));
            if (this.checked) {
                shops.push(this.shopId);
            }
            this.setShops(shops);
            this.$root.selectedShopCount = shops.length;
        },
    }
}
</script>
